import type { $Fetch } from 'nitropack';
import type { CreateOrderError } from './types/checkout';
import type { PaymentMethod } from '~/composables/custom/usePayment/usePayment';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const getPaymentMethods = async (orderNumber?: string | undefined) => $fetch<BFFResponse<PaymentMethod[]>>(orderNumber ? `/checkout/paymentMethods/${orderNumber}` : `/checkout/paymentMethods/`);

  const saveBillingInfo = async (body: any) => $fetch<BFFResponse<unknown>>('/checkout/saveBillingInfo', { method: 'POST', body });

  const saveShippingInfo = async (body: any) => $fetch<BFFResponse<unknown>>('/checkout/saveShippingInfo', { method: 'POST', body });

  const createOrder = async (orderNumber: string | undefined, body: any) => $fetch<BFFResponse<{ redirectUrl?: string }, { error: CreateOrderError; errors: unknown[] }>>(`/checkout/createOrder${orderNumber ? '/' + orderNumber : ''}`, { method: 'POST', body });

  const saveDhlShippingInfo = async (body: any) => $fetch<BFFResponse<unknown>>('/checkout/saveShippingInfo/dhl', { method: 'POST', body });

  const saveInPostShippingInfo = async (body: any) => $fetch<BFFResponse<unknown>>('/checkout/saveShippingInfo/inPost', { method: 'POST', body });

  return {
    getPaymentMethods,
    saveBillingInfo,
    saveShippingInfo,
    createOrder,
    saveDhlShippingInfo,
    saveInPostShippingInfo,
  };
};
